module.exports = __webpack_public_path__ + "static/remy-4174dde1d485730aa4cc21280604b868.png";